import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
interface Quote {
  nombre: string;
  compra: number;
  venta: number;
}
const FALLBACK: Quote[] = [{
  nombre: 'Oficial',
  compra: 1450,
  venta: 1500
}, {
  nombre: 'Blue',
  compra: 1495,
  venta: 1515
}, {
  nombre: 'Bolsa',
  compra: 1515,
  venta: 1519
}, {
  nombre: 'Contado con liquidación',
  compra: 1561,
  venta: 1563
}, {
  nombre: 'Mayorista',
  compra: 1473,
  venta: 1482
}, {
  nombre: 'Cripto',
  compra: 1511,
  venta: 1511
}, {
  nombre: 'Tarjeta',
  compra: 1885,
  venta: 1950
}];
const formatMoney = (n: number) => n.toLocaleString('es-AR', {
  minimumFractionDigits: 0,
  maximumFractionDigits: 2
});
export function MarketTicker() {
  const [quotes, setQuotes] = useState<Quote[]>(FALLBACK);
  const [updatedAt, setUpdatedAt] = useState<string | null>(null);
  const fetchQuotes = async () => {
    try {
      const res = await fetch('https://dolarapi.com/v1/dolares');
      if (!res.ok) throw new Error('bad response');
      const data = await res.json();
      if (Array.isArray(data) && data.length) {
        setQuotes(data.map((d: any) => ({
          nombre: d.nombre,
          compra: d.compra,
          venta: d.venta
        })));
        const latest = data.find((d: any) => d.fechaActualizacion);
        if (latest) {
          setUpdatedAt(new Date(latest.fechaActualizacion).toLocaleTimeString('es-AR', {
            hour: '2-digit',
            minute: '2-digit'
          }));
        }
      }
    } catch {
      // keep fallback quietly
    }
  };
  useEffect(() => {
    fetchQuotes();
    const interval = setInterval(fetchQuotes, 60000);
    return () => clearInterval(interval);
  }, []);
  const items = [...quotes];
  if (updatedAt) {
    items.push({
      nombre: `Actualizado ${updatedAt} hs`,
      compra: 0,
      venta: 0
    });
  }
  const renderItem = (q: Quote, key: React.Key) => {
    const isMeta = q.compra === 0 && q.venta === 0;
    return <div key={key} className="flex items-center whitespace-nowrap px-6" data-id="element-86">
        {isMeta ? <span className="text-slate-400 text-xs font-medium" data-id="element-87">{q.nombre}</span> : <>
            <span className="text-white font-semibold text-sm" data-id="element-88">
              {q.nombre}:
            </span>
            <span className="ml-2 text-emerald-400 font-semibold text-sm tabular-nums" data-id="element-89">
              ${formatMoney(q.compra)}
            </span>
            <span className="mx-1 text-slate-500" data-id="element-90">/</span>
            <span className="text-sky-300 font-semibold text-sm tabular-nums" data-id="element-91">
              ${formatMoney(q.venta)}
            </span>
          </>}
        <span className="ml-6 text-slate-600" aria-hidden="true" data-id="element-92">
          •
        </span>
      </div>;
  };
  return <div className="fixed top-0 left-0 right-0 z-[60] h-9 bg-[#0a2540] border-b border-[#1a365d] overflow-hidden flex items-center" data-id="element-93">
      <div className="flex items-center" data-id="element-94">
        <div className="flex-shrink-0 flex items-center gap-1.5 bg-blue-700 h-9 px-3" data-id="element-95">
          <span className="relative flex h-2 w-2" data-id="element-96">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-300 opacity-75" data-id="element-97"></span>
            <span className="relative inline-flex rounded-full h-2 w-2 bg-green-400" data-id="element-98"></span>
          </span>
          <span className="text-white text-[11px] font-bold uppercase tracking-wide" data-id="element-99">
            Mercado
          </span>
        </div>
      </div>

      <div className="relative flex-1 overflow-hidden" data-id="element-100">
        <motion.div className="flex items-center" animate={{
        x: ['0%', '-50%']
      }} transition={{
        ease: 'linear',
        duration: 40,
        repeat: Infinity
      }} data-id="element-101">
          <div className="flex items-center" data-id="element-102">
            {items.map((q, i) => renderItem(q, `a-${i}`))}
          </div>
          <div className="flex items-center" aria-hidden="true" data-id="element-103">
            {items.map((q, i) => renderItem(q, `b-${i}`))}
          </div>
        </motion.div>
      </div>
    </div>;
}